import "./Capabilities.css";
import Footer from "./Footer";
import rndBefore from "../assets/rnd-before.png";
import rndAfter from "../assets/rnd-after.png";

import { FaUniversity, FaFlask, FaCertificate } from "react-icons/fa";

export default function CapResearch() {
  return (
    <section id="cap-res">

      {/* =========================================
          TOP SECTION - RESEARCH & DEVELOPMENT
          ========================================= */}

      <div className="capability-wrapper-a">

        {/* LEFT CONTENT */}

        <div className="capability-text-a">

          <h3>
            Research & Development – Lightweight Aluminium Innovation
          </h3>

          <h3>
            Engineered lightweighting through innovative casting.
          </h3>

          <p>
            At SCL, Research & Development is the engine behind our
            lightweight aluminium solutions. Our teams develop advanced
            alloys, casting processes and surface engineering techniques
            that push the limits of performance, efficiency and
            sustainability. Combining decades of die-casting experience
            with new-generation technologies, we help customers take
            breakthrough concepts from prototype to series production –
            faster, cleaner and smarter.
          </p>

        </div>

      </div>


      {/* =========================================
          PRODUCT DESIGN OPTIMISATION
          ========================================= */}

      <h2 className="capability-title">
        Product Design Optimisation
      </h2>

      <div className="cap-underline"></div>


      <p className="product-design-description">
        Using advanced simulation and structural analysis, our engineering
        teams refine component design to reduce weight and stress
        concentration while maintaining strength — delivering a lighter,
        more efficient part without compromising performance.
      </p>


      {/* BEFORE / AFTER IMAGES */}

      <div className="rnd-compare-wrapper">

        {/* BEFORE OPTIMISATION */}

        <div className="rnd-compare-card">

          <div className="rnd-compare-image">
            <img
              src={rndBefore}
              alt="Product design before optimisation"
            />
          </div>

        </div>


        {/* AFTER OPTIMISATION */}

        <div className="rnd-compare-card">

          <div className="rnd-compare-image">
            <img
              src={rndAfter}
              alt="Product design after optimisation"
            />
          </div>

        </div>

      </div>


      {/* =========================================
          KEY CAPABILITIES & BENEFITS
          ========================================= */}

      <h2 className="capability-title key-capability-title">
        Key Capabilities & Benefits
      </h2>

      <div className="cap-underline"></div>


      <p
        className="key-capability-description"
      >
        We create value through a deep understanding of design, materials
        and process behaviour, translating engineering insight into
        measurable gains in weight, durability and cost for our customers.
      </p>


      {/* =========================================
          KEY CAPABILITY CARDS - ROW 1
          ========================================= */}

      <div className="cap-wrapper">

        {/* CARD 1 */}

        <div className="cap-card">

          <div className="cap-header">
            Expertise in Broad Product Portfolio
          </div>

          <div className="cap-body">

            <ul>

              <li>
                We manage over 300 part numbers simultaneously, from 25
                grams to more than 30 kilograms, across both low- and
                high-volume programmes. This gives customers scalability
                and flexibility across multiple vehicle segments.
              </li>

            </ul>

          </div>

        </div>


        {/* CARD 2 */}

        <div className="cap-card">

          <div className="cap-header">
            From Prototype to Series Production
          </div>

          <div className="cap-body">

            <p>
              SCL supports the full journey from engineering samples and
              proto tools through PPAP to stable series production,
              ensuring manufacturability, robustness and consistent
              quality at every stage.
            </p>

          </div>

        </div>


        {/* CARD 3 */}

        <div className="cap-card">

          <div className="cap-header">
            Global Engineering Support
          </div>

          <div className="cap-body">

            <p>
              Our EU Design Centre in Germany and SCL plant in South
              Carolina, USA enable on-site collaboration, rapid design
              loops and faster responses for global programmes in
              structural, lightweight and EV applications.
            </p>

          </div>

        </div>

      </div>


      {/* =========================================
          KEY CAPABILITY CARDS - ROW 2
          ========================================= */}

      <div className="cap-wrapper">

        {/* CARD 4 */}

        <div className="cap-card">

          <div className="cap-header">
            Sustainable Aluminium Solutions
          </div>

          <div className="cap-body">

            <p>
              We use low-CO₂ aluminium aligned with SCL's sustainability
              roadmap and our commitment to achieve Scope 1 and Scope 2 net-zero emissions
              before 2040, helping customers lower the embedded carbon
              of their components.
            </p>

          </div>

        </div>


        {/* CARD 5 */}

        <div className="cap-card">

          <div className="cap-header">
            Surface Finish Innovation
          </div>

          <div className="cap-body">

            <p>
              A patented surface polishing process for compressor
              housings achieves internal volute roughness below 3 μm,
              improving airflow efficiency and boosting overall product
              performance.
            </p>

          </div>

        </div>


        {/* CARD 6 */}

        <div className="cap-card">

          <div className="cap-header">
            Rheocasting Technology
          </div>

          <div className="cap-body">

            <p>
              Our rheocasting capabilities allow aluminium to replace
              forged steel or cast iron, delivering up to 50% weight
              reduction while maintaining structural integrity for
              demanding applications.
            </p>

          </div>

        </div>

      </div>


      {/* =========================================
          INNOVATION THROUGH PARTNERSHIP
          ========================================= */}

      <h2 className="capability-title innovation-title">
        Innovation through Partnership
      </h2>

      <div className="cap-underline"></div>


      <div className="rnd-banner">

        <div className="rnd-banner-flex">

          {/* UNIVERSITY / INSTITUTION LIST */}

          <div className="rnd-partners-list">

            <h4>Our Collaborations</h4>

            <ul>
              <li>Massachusetts Institute of Technology, USA</li>
              <li>NADCA, USA</li>
              <li>Ryerson University, Canada</li>
              <li>Fraunhofer Institutes, Germany</li>
              <li>Aachen University, Germany</li>
              <li>CSIRO, Australia</li>
              <li>Warwick University, UK</li>
              <li>Indian Institute of Technology, Madras</li>
              <li>Indian Institute of Science, Bangalore</li>
            </ul>

          </div>


          {/* INFOGRAPHIC */}

          <div className="rnd-infographic">

            {/* STEP 1 */}

            <div className="rnd-info-point">

              <span className="rnd-step-num">
                1
              </span>

              <div className="rnd-icon-badge">

                <FaUniversity className="rnd-info-icon" />

              </div>

              <h4>
                Academic Collaboration
              </h4>

              <p>
                Partnering with institutions such as IIT Madras to
                co-develop advanced casting and metallurgy research.
              </p>

            </div>


            {/* CONNECTOR */}

            <div className="rnd-connector">

              <span className="rnd-connector-dashes"></span>

              <span className="rnd-connector-arrow">
                →
              </span>

            </div>


            {/* STEP 2 */}

            <div className="rnd-info-point">

              <span className="rnd-step-num">
                2
              </span>

              <div className="rnd-icon-badge">

                <FaFlask className="rnd-info-icon" />

              </div>

              <h4>
                Applied R&D
              </h4>

              <p>
                Proprietary, patented process and surface engineering
                technologies developed through hands-on innovation.
              </p>

            </div>


            {/* CONNECTOR */}

            <div className="rnd-connector">

              <span className="rnd-connector-dashes"></span>

              <span className="rnd-connector-arrow">
                →
              </span>

            </div>


            {/* STEP 3 */}

            <div className="rnd-info-point">

              <span className="rnd-step-num">
                3
              </span>

              <div className="rnd-icon-badge">

                <FaCertificate className="rnd-info-icon" />

              </div>

              <h4>
                Technology Leadership
              </h4>

              <p>
                Reinforcing SCL's position as a global technology leader
                in aluminium die-casting.
              </p>

            </div>

          </div>

        </div>

      </div>


      {/* =========================================
          PATENTS
          ========================================= */}

      <h2 className="capability-title patents-title">
        Patents
      </h2>

      <div className="cap-underline"></div>

      <p className="key-capability-description">
        Our patented technologies reflect SCL's continued investment in
        proprietary process innovation and engineering excellence.
      </p>

      <div className="cap-wrapper">

        {/* PATENT 1 */}

        <div className="cap-card">

          <div className="cap-header">
            Aluminium Foam Pillion Handle
          </div>

          <div className="cap-body">

            <p>
              Aluminium foam pillion handle for two-wheeler application.
              <br />
              Indian Patent: 497319
            </p>

          </div>

        </div>


        {/* PATENT 2 */}

        <div className="cap-card">

          <div className="cap-header">
            Battery Box Bend Correction
          </div>

          <div className="cap-body">

            <p>
              Floating insert technology-based bend correction for
              battery box using tri-axial compression.
              <br />
              Indian Patent: 447813
            </p>

          </div>

        </div>


        {/* PATENT 3 */}

        <div className="cap-card">

          <div className="cap-header">
            Abrasive Flow Machining Process
          </div>

          <div className="cap-body">

            <p>
              Abrasive flow machining process for improvement in surface
              finish of volute in GDC compressor housings.
              <br />
              India, Europe, North America
            </p>

          </div>

        </div>

      </div>


      <div className="cap-wrapper">

        {/* PATENT 4 */}

        <div className="cap-card">

          <div className="cap-header">
            Abrasive Flow Machining Fixture & Machine
          </div>

          <div className="cap-body">

            <p>
              Development of fixture and machine for abrasive flow
              machining of compressor housing.
              <br />
              India, Europe, North America
            </p>

          </div>

        </div>


        {/* PATENT 5 */}

        <div className="cap-card">

          <div className="cap-header">
            Anchorage Muffler Bend Correction
          </div>

          <div className="cap-body">

            <p>
              Floating insert technology-based bend correction for
              anchorage muffler using hoop compressive stress.
              <br />
              Indian Patent: 448808
            </p>

          </div>

        </div>

      </div>


      {/* FOOTER */}

      <Footer />

    </section>
  );
}
